import React from "react";
import { Button, ButtonGroup, Card } from "react-bootstrap";
import { AiFillProfile } from "react-icons/ai";
import { BsXCircleFill } from "react-icons/bs";
import { GrEdit } from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import { DownloadTxt } from "../PanelCoordenadas/DownloadTXT"; 
import './RutasStyles.css' 
   
export function RutasCard({ ruta, empresaNombre, datosAEditar, handleEliminar }) {
  const navigation = useNavigate();
  const protocoloLabel =
    ruta?.protocolosModel?.codigo ??
    ruta?.protocolosModel?.nombre ??
    "MT-2";
 
  return (
    <Card key={ruta.id} className="cardRuta">
      <Card.Body>
        <Card.Title className="cardRuta-title">Id de ruta {ruta.id}</Card.Title>
        <Card.Subtitle className="cardRuta-subtitle">Nombre de Ruta: {ruta.nomruta}</Card.Subtitle>
        <Card.Text className="cardRuta-text">Empresa: {empresaNombre}</Card.Text>
        <Card.Text className="cardRuta-text">País: {ruta.paisesModel && ruta.paisesModel.nombre}</Card.Text>
        <Card.Text className="cardRuta-text">Protocolo: {protocoloLabel}</Card.Text>
      </Card.Body>
      <Button onClick={() => navigation(`/coordenadas/${ruta.id}`)} className="boton-ver">
        <AiFillProfile /> Ver Coordenadas
      </Button>
      <DownloadTxt ruta={ruta.id} className="boton-descargar" />
      <ButtonGroup className="contenedor-botones">
        <Button variant="warning" onClick={() => datosAEditar(ruta)} className="boton-editar">
          <GrEdit /> Editar
        </Button>
        <Button variant="danger" onClick={() => handleEliminar(ruta.id)} className="boton-eliminar">
          <BsXCircleFill /> Eliminar
        </Button>
      </ButtonGroup>
    </Card>
  );
}
 
